import React from 'react';

import AppPieceDisplay from '../display/app_piece.js';
import ArticleDisplay from '../display/article.js';
import CodePieceDisplay from '../display/code_piece.js';
import ImagePieceDisplay from '../display/image_piece.js';
import InfocardPieceDisplay from '../display/infocard_piece.js';
import MoviePieceDisplay from '../display/movie_piece.js';
import QaDisplay from '../display/qa.js';
import RatingPieceDisplay from '../display/rating_piece.js';
import ReviewExtraDisplay from '../display/review_extra.js';
import SongPieceDisplay from '../display/song_piece.js';
import TwitterPieceDisplay from '../display/twitter_piece.js';
import VideoDisplay from '../display/video.js';
import VideoPieceDisplay from '../display/video_piece.js';
import AppExtractor from '../extractor/app.js';
import ArticleExtractor from '../extractor/article.js';
import CodeExtractor from '../extractor/code.js';
import ExtractorExtractor from '../extractor/extractor.js';
import ImageExtractor from '../extractor/image.js';
import InfocardExtractor from '../extractor/infocard.js';
import MovieExtractor from '../extractor/movie.js';
import QaExtractor from '../extractor/qa.js';
import RatingExtractor from '../extractor/rating.js';
import ReviewExtractor from '../extractor/review.js';
import SongExtractor from '../extractor/song.js';
import TwitterExtractor from '../extractor/twitter.js';
import VideoExtractor from '../extractor/video.js';


/*
import ArticleExtractor from '../extractor/article.js';
import SongExtractor from '../extractor/song.js';
import AppExtractor from '../extractor/app.js';
import VideoExtractor from '../extractor/video.js';
import QAExtractor from '../extractor/qa.js';
import ReviewExtractor from '../extractor/review.js';
import TwitterExtractor from '../extractor/twitter.js';
import InstagramExtractor from '../extractor/instagram.js';
import InfoCardExtractor from '../extractor/infocard.js';
import RatingExtractor from '../extractor/rating.js';
import MovieExtractor from '../extractor/movie.js';
import ImageExtractor from '../extractor/images.js';
import CodeExtractor from '../extractor/code.js';
import ArticleDisplay from '../display/article.js';
import VideoDisplay from '../display/video.js';
import VideoPiece from '../display/video_piece.js';
import QADisplay from '../display/qa.js';
import ReviewDisplay from '../display/review.js';
import SongPiece from '../display/song_piece.js';
import AppPiece from '../display/app_piece.js';
import TwitterPiece from '../display/twitter_piece.js';
import InstagramPiece from '../display/instagram_piece.js';
import InfoCardPiece from '../display/infocard_piece.js';
import RatingPiece from '../display/rating_piece.js';
import MoviePiece from '../display/movie_piece.js';
import ImagePiece from '../display/image_piece.js';
import CodePiece from '../display/code_piece.js';
*/

class HandlersIndex {
  constructor(){
    this.renderers = [
			{name : 'App Piece',            meta : 'app-piece',            type: 'piece',           render: function(data, params){return <AppPieceDisplay key={params.key} data={data}/>}},
			{name : 'Article',              meta : 'article',              type: 'result',          render: function(data, params){return <ArticleDisplay key={params.key} data={data}/>}},
			{name : 'Code Piece',           meta : 'code-piece',           type: 'piece',           render: function(data, params){return <CodePieceDisplay key={params.key} data={data}/>}},
			{name : 'Image Piece',          meta : 'image-piece',          type: 'piece',           render: function(data, params){return <ImagePieceDisplay key={params.key} data={data}/>}},
			{name : 'Infocard Piece',       meta : 'infocard-piece',       type: 'piece',           render: function(data, params){return <InfocardPieceDisplay key={params.key} data={data}/>}},
			{name : 'Movie Piece',          meta : 'movie-piece',          type: 'piece',           render: function(data, params){return <MoviePieceDisplay key={params.key} data={data}/>}},
			{name : 'Qa',                   meta : 'qa',                   type: 'result',          render: function(data, params){return <QaDisplay key={params.key} data={data}/>}},
			{name : 'Rating Piece',         meta : 'rating-piece',         type: 'piece',           render: function(data, params){return <RatingPieceDisplay key={params.key} data={data}/>}},
			{name : 'Review Extra',         meta : 'review-extra',         type: 'result-extra',    render: function(data, params){return <ReviewExtraDisplay key={params.key} data={data}/>}},
			{name : 'Song Piece',           meta : 'song-piece',           type: 'piece',           render: function(data, params){return <SongPieceDisplay key={params.key} data={data}/>}},
			{name : 'Twitter Piece',        meta : 'twitter-piece',        type: 'piece',           render: function(data, params){return <TwitterPieceDisplay key={params.key} data={data}/>}},
			{name : 'Video',                meta : 'video',                type: 'result',          render: function(data, params){return <VideoDisplay key={params.key} data={data}/>}},
			{name : 'Video Piece',          meta : 'video-piece',          type: 'piece',           render: function(data, params){return <VideoPieceDisplay key={params.key} data={data}/>}},

    ];
    /*
    this.renderers = [
      {name : 'Video Result',     meta : 'video-result',    type: 'result',       render: function(data, params){return <VideoDisplay key={params.key} data={data}/>}},
      {name : 'Article Result',   meta : 'article',         type: 'result',       render: function(data, params){return <ArticleDisplay key={params.key} data={data}/>}},
      {name : 'Q&A Result',       meta : 'qa',              type: 'result',       render: function(data, params){return <QADisplay key={params.key} data={data}/>}},
      {name : 'Review Result',    meta : 'review',          type: 'result-extra', render: function(data, params){return <ReviewDisplay key={params.key} data={data}/>}},
      {name : 'Video Piece',      meta : 'video-piece',     type: 'piece',        render: function(data, params){return <VideoPiece key={params.key} data={data}/>}},
      {name : 'Song Piece',       meta : 'song',            type: 'piece',        render: function(data, params){return <SongPiece key={params.key} data={data}/>}},
      {name : 'App Piece',        meta : 'app-piece',       type: 'piece',        render: function(data, params){return <AppPiece key={params.key} data={data}/>}},
      {name : 'Twitter Piece',    meta : 'twitter_piece',   type: 'piece',        render: function(data, params){return <TwitterPiece key={params.key} data={data}/>}},
      {name : 'Instagram Piece',  meta : 'instagram_piece', type: 'piece',        render: function(data, params){return <InstagramPiece key={params.key} data={data}/>}},
      {name : 'InfoCard Piece',   meta : 'infocard_piece',  type: 'piece',        render: function(data, params){return <InfoCardPiece key={params.key} data={data}/>}},
      {name : 'Rating Piece',     meta : 'rating_piece',    type: 'piece',        render: function(data, params){return <RatingPiece key={params.key} data={data}/>}},
      {name : 'Movie Piece',      meta : 'movie_piece',     type: 'piece',        render: function(data, params){return <MoviePiece key={params.key} data={data}/>}},
      {name : 'Image Piece',      meta : 'image_piece',     type: 'piece',        render: function(data, params){return <ImagePiece key={params.key} data={data}/>}},
      {name : 'Code Piece',       meta : 'code_piece',      type: 'piece',        render: function(data, params){return <CodePiece key={params.key} data={data}/>}},
    ];
    */

    this.handlers = [
			{name : 'App',        meta : 'app',        extractor: new AppExtractor()},
			{name : 'Article',    meta : 'article',    extractor: new ArticleExtractor()},
			{name : 'Code',       meta : 'code',       extractor: new CodeExtractor()},
			{name : 'Extractor',  meta : 'extractor',  extractor: new ExtractorExtractor()},
			{name : 'Image',      meta : 'image',      extractor: new ImageExtractor()},
			{name : 'Infocard',   meta : 'infocard',   extractor: new InfocardExtractor()},
			{name : 'Movie',      meta : 'movie',      extractor: new MovieExtractor()},
			{name : 'Qa',         meta : 'qa',         extractor: new QaExtractor()},
			{name : 'Rating',     meta : 'rating',     extractor: new RatingExtractor()},
			{name : 'Review',     meta : 'review',     extractor: new ReviewExtractor()},
			{name : 'Song',       meta : 'song',       extractor: new SongExtractor()},
			{name : 'Twitter',    meta : 'twitter',    extractor: new TwitterExtractor()},
			{name : 'Video',      meta : 'video',      extractor: new VideoExtractor()},

    ];
    /*
    this.handlers = [
      {name : 'Video Handler',      meta : 'video',     extractor: new VideoExtractor()},
      {name : 'Article Handler',    meta : 'article',   extractor: new ArticleExtractor()},
      {name : 'Q&A Handler',        meta : 'qa',        extractor: new QAExtractor()},
      {name : 'Review Handler',     meta : 'review',    extractor: new ReviewExtractor()},
      {name : 'Song Handler',       meta : 'song',      extractor: new SongExtractor()},
      {name : 'App Handler',        meta : 'app',       extractor: new AppExtractor()},
      {name : 'Twitter Handler',    meta : 'twitter',   extractor: new TwitterExtractor()},
      {name : 'Instagram Handler',  meta : 'instagram', extractor: new InstagramExtractor()},
      {name : 'Infocard Handler',   meta : 'infocard',  extractor: new InfoCardExtractor()},
      {name : 'Rating Handler',     meta : 'rating',    extractor: new RatingExtractor()},
      {name : 'Movie Handler',      meta : 'movie',     extractor: new MovieExtractor()},
      {name : 'Image Handler',      meta : 'image',     extractor: new ImageExtractor()},
      {name : 'Code Handler',       meta : 'code',      extractor: new CodeExtractor()},
    ];
    */
  }
}

export default HandlersIndex;



// WEBPACK FOOTER //
// ./src/search/admin/handlers_index.js